export default __webpack_public_path__ + "static/media/cover-card-email-optin.87aae71c.svg";